import React from 'react';
import { User } from 'lucide-react';
import { ValidationBadge } from '../ValidationBadge';
import { adminConfirmation, formatAdminDate } from '../../../data/guide/adminConfirmations';
export const QUEST_SOLO_KEY = 'quest-drop:party';

/** Regla del staff: los objetos de misión son individuales y no caen si vas en party. */
export function QuestSoloNote() {
  const a = adminConfirmation(QUEST_SOLO_KEY);
  if (!a) return null;
  return <div className="mt-2 flex flex-col gap-1.5 rounded-lg border border-[#D4AF37]/30 bg-[#D4AF37]/[0.06] px-3 py-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-1068" data-mp="1us6gm5lmdqhs">
      <p className="flex items-start gap-2 text-xs font-semibold text-[#F3E5AB]" data-id="element-1069" data-mp="1l00sj6yhnt7v">
        <User className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-1070" data-mp="1gzgwy7tkcxnu" />
        Caza solo: los objetos de misión son individuales y no caen si estás en party.
      </p>
      <ValidationBadge status="admin" label={`Confirmado por administración · ${formatAdminDate(a.date)}`} data-id="element-1071" data-mp="1c26v1sozmtj4" />
    </div>;
}